import React from 'react';
import { FormViewContent } from 'components/FormViewContent';
import { MUITextBox } from 'components/FormHelpers/FormInputs';
import PropTypes from 'prop-types';

const PSRMultilineTextControl = ({
  name,
  value,
  onChange,
  textpsrField,
  primaryText,
  validators,
  errorMessages,
  isDisabled
}) => (
  <FormViewContent
    primaryText={primaryText}
    secondaryText={(
      <MUITextBox
        title={primaryText}
        className={textpsrField}
        variant="outlined"
        validators={validators}
        errorMessages={errorMessages}
        id="outlined-multiline-static"
        name={name}
        multiline
        rows="3"
        value={value}
        onChange={onChange}
        disabled={isDisabled}
      />
   )}
  />
);

PSRMultilineTextControl.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  textpsrField: PropTypes.string.isRequired,
  validators: PropTypes.arrayOf(
    PropTypes.string
  ),
  errorMessages: PropTypes.arrayOf(
    PropTypes.string
  ),
  isDisabled: PropTypes.bool.isRequired
};

PSRMultilineTextControl.defaultProps = {
  value: '',
  validators: [],
  errorMessages: []
};

export default PSRMultilineTextControl;
